import React from 'react';

import { Show, TextField, EmailField, ReferenceField, SimpleShowLayout, SelectField, useTranslate } from 'react-admin';

import { PhoneField } from '../../../components/fields/PhoneField';
import { ActionsWithBackButton } from '../../../components/actionbars/ActionsWithBackButton';

import { SysNotifTypeRepresentTranslationChoices, SysNotifEventsChoices } from '../../../entities/SysNotifTypes';
import BitwiseArrayField from '../../../components/fields/BitwiseArrayField';


export const DriverShow = (props) => {
	const t = useTranslate();

	const notifEventChoices = SysNotifEventsChoices.map(el => ({id: el.id, name: t(`osfc.enums.sysnotifevent.${el.name}`)}));

	return (
		<Show actions={<ActionsWithBackButton />} {...props}>
			<SimpleShowLayout>
				<TextField source="id" />
				<TextField source="first_name" />
				<TextField source="last_name" />
				<ReferenceField source="truck_id" reference={"trucks"} link={false}>
					<TextField source="name" />
				</ReferenceField>
				<EmailField source="email" />
				<PhoneField source="phone" />
				<BitwiseArrayField source="sys_notif_type" options={SysNotifTypeRepresentTranslationChoices} />
				<SelectField source="sys_notif_events" choices={notifEventChoices} />
			</SimpleShowLayout>
		</Show>
	);
};
